import { useTranslation } from "react-i18next";
import "./buttonNew.scss";
import { IButtonDropdownProps } from "./buttonPropertiesInterfaceNew";
import { ReactComponent as Arrow } from 'itd-common/assets/icons/arrow.svg';

export default function DropdownButton({ disabled, onClick, label, isCollapsed, key }: IButtonDropdownProps) {

  const handleClick = (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    if (disabled) return;
    if (typeof onClick === 'function') {
      onClick(); 
    }
  };

  return (
    <button
        type="button"
        className="button__header"
        onClick={handleClick}
        aria-expanded={!isCollapsed}
        aria-controls={`group-items-${key}`}
        >
        <span className="button__title">{label}</span>
        <span className="button-toggle-icon" aria-hidden="true"><Arrow /></span>
    </button>
  );
}